import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';
import { ProjectActivityDto } from './project-activity.dto';
import { ProgressHistoryReportDto } from './progress-history-report.dto';
import { ProgressMeetingReportDto } from './progress-meeting-report.dto';
import { ProjectClusterDto } from './project-cluster.dto';
import { ProjectStakeholderDto } from './project-stakeholder.dto';
import { ProjectDocumentDto } from './project-document.dto';
import { ProjectPaymentDto } from './project-payment.dto';
import { ProgressReportMasterDto } from './project-report-master.dto';


export class ProjectDto extends EpimsBaseEntityDto {
  ProjectId: string;
   Description: string;
  Location: string;
   Objective: string;
  @IsNotEmpty() Executor: string;
  @IsNotEmpty() StartDate: Date;
  @IsNotEmpty() EndDate: Date;
  @IsNotEmpty() Budget: number;
   BudgetSpent: number;
 MilestonePayment: number;
  Milestone: string;
  CurrencyId: string;
  @IsNotEmpty() Status: string;
  @IsNotEmpty() ProjectTitle: string;
  @IsNotEmpty() GMOUId: string;
  @IsNotEmpty() GMOUCategoryId: string;
  @IsNotEmpty() GMOUTypeId: string;
  @IsNotEmpty() OilBlocId: string;
  @IsNotEmpty() OilFieldId: string;
  @IsNotEmpty() StateId: string;
  @IsNotEmpty() LGAId: string;
  projectPayments?: any[];
  projectDocuments?: ProjectDocumentDto[];
  projectStakeholders?: ProjectStakeholderDto[];
  projectClusters?: ProjectClusterDto[];
  projectMeetingReports?: ProgressMeetingReportDto[];
  projectHistoryReports?: ProgressHistoryReportDto[];
  projectActivities?: ProjectActivityDto[];
  progressReportMasters?: ProgressReportMasterDto[];
}
